import { Form } from 'antd';
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { GroupListComponents } from '../group/GroupListComponents';

const GroupListComponentsForm: any = Form.create()(GroupListComponents);
interface Props extends RouteComponentProps<{ teacherId: string }> {}
interface State {}
export class TeacherGroups extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }
  render() {
    return <GroupListComponentsForm {...this.props} teacherIds={this.props.match.params.teacherId} />;
  }
}



// WEBPACK FOOTER //
// ./src/screens/teacher/TeacherGroups.tsx